<template>
  <div v-if="visible">
    <a class="context__menu-item-link" @click="$refs.modal.show()">
      <i class="context__menu-item-icon iconoir-community"></i>
      Gestionar miembros
    </a>
    <GestionarMiembrosModal
      ref="modal"
      :tipo="table ? 'tabla' : 'aplicacion'"
      :recurso-id="(table || application).id"
      :nombre="(table || application).name"
    />
  </div>
</template>

<script>
/**
 * "Gestionar miembros" en el menú de una base (recibe `application`) o de una
 * tabla (recibe `table` y `database`). Es lo que enterprise ofrece con candado;
 * aquí funciona. Solo se enseña a quien puede usarlo: el admin del espacio y el
 * Encargado de esa base o tabla.
 */
import GestionarMiembrosModal from '@extras_mg/components/GestionarMiembrosModal'
import { puedeAdministrar } from '@extras_mg/utils/roles'

export default {
  name: 'GestionarMiembrosItem',
  components: { GestionarMiembrosModal },
  props: {
    application: { type: Object, default: null },
    database: { type: Object, default: null },
    table: { type: Object, default: null },
  },
  computed: {
    aplicacion() {
      return this.application || this.database
    },
    visible() {
      if (!this.aplicacion) return false
      const workspace = this.$store.getters['workspace/get'](
        this.aplicacion.workspace.id
      )
      const objeto = (workspace?._?.permissions || []).find(
        (p) => p.name === 'mg_roles'
      )
      return puedeAdministrar(
        objeto?.permissions,
        this.aplicacion.id,
        this.table ? this.table.id : null
      )
    },
  },
}
</script>
